import { Component } from 'preact'
import * as firebase from 'firebase'

class FirebaseComponent extends Component {
  constructor() {
		super()

		const config = {
			apiKey: process.env.REACT_APP_API_KEY,
			authDomain: process.env.REACT_APP_AUTH_DOMAIN,
			databaseURL: process.env.REACT_APP_DATABASE_URL,
			projectId: process.env.REACT_APP_PROJECT_ID,
			storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
      messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID
		};

    if (firebase.apps.length === 0) {
      firebase.initializeApp(config);
    }

    const currentUser = firebase.auth().currentUser
    const uid = currentUser ? currentUser.uid : null

    this.state = {
      isAuthed: currentUser != null,
      uid
    }

    firebase.auth().onAuthStateChanged(user => {
      if (user) {
        this.setState({ isAuthed: true, uid: user.uid })
      } else {
        this.setState({ isAuthed: false, uid: null })
      }
    })
  }
}

export default FirebaseComponent



// WEBPACK FOOTER //
// ./src/FirebaseComponent.js